import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { get } from '../../../../common/axiosClient';

export interface AuthorInfo {
  name: string;
  signatureUrl?: string;
  email?: string;
}

export const useAuthorInfo = () => {
  type UserProfile = { firstName: string; lastName?: string | null; signatureUrl?: string; email?: string };

  const { data: userProfile, isLoading: isLoadingProfile } = useQuery<UserProfile>('currentUserProfile', async () => {
    const res = (await get(`/user/profile`)) as any;
    return res as UserProfile;
  });

  const authorInfo: AuthorInfo | undefined = useMemo(() => {
    if (!userProfile) return undefined;
    const firstName = userProfile.firstName || '';
    const lastName = userProfile.lastName || '';
    const fullName = `${firstName}${lastName ? ` ${lastName}` : ''}`.trim();
    return { name: fullName, signatureUrl: userProfile.signatureUrl, email: userProfile.email };
  }, [userProfile]);

  return { authorInfo, isLoading: isLoadingProfile } as const;
};
